export const SCOREBOARD_CHANNEL = "scoreboard:mat";

export function getScoreboardMatChannel(matId) {
    return `${SCOREBOARD_CHANNEL}:${matId}`;
}

export function extractMatIdFromChannel(channel: string): number | null {
    // Channel format is "prefix:mat:matId" (e.g., "scoreboard:mat:1")
    const parts = channel.split(":");
    if (parts.length === 3) {
        const matId = parseInt(parts[2], 10);
        return isNaN(matId) ? null : matId;
    }
    return null;
}

export const CALL_OF_THE_COMPETITOR_CHANNEL = "call-of-the-competitor:mat";

export function getCalledCompetitorsChannel(matId: number): string {
    return `${CALL_OF_THE_COMPETITOR_CHANNEL}:${matId}`;
}

const ANNOUNCER_BOARD_CALL_COUNT_UPDATES = "announcer-board:call-count-updates";

export function getAnnouncerBoardCallCountUpdatesChannel(eventId: number): string {
    return `${ANNOUNCER_BOARD_CALL_COUNT_UPDATES}:${eventId}`;
}
